// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-ics-button--hide-label-on-mobile .ant-btn-icon {
  margin-inline-end: 0px !important;
}
@media (min-width: 768px) {
  .download-ics-button--hide-label-on-mobile .ant-btn-icon {
    margin-inline-end: 8px !important;
  }
}
.download-ics-button--hide-label-on-mobile .download-ics-button__label {
  display: none !important;
  margin-right: -5px;
}
@media (min-width: 768px) {
  .download-ics-button--hide-label-on-mobile .download-ics-button__label {
    display: inline-block !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Buttons/DownloadICSButton/DownloadICSButton.scss"],"names":[],"mappings":"AAIQ;EACI,iCAAA;AAHZ;AAKY;EAHJ;IAIQ,iCAAA;EAFd;AACF;AAMI;EACI,wBAAA;EACA,kBAAA;AAJR;AAMQ;EAJJ;IAKQ,gCAAA;EAHV;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
